var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 5v14M5 12h14"}));
}

PlusInline.defaultProps = {"viewBox":"0 0 24 24","className":"stroke"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
